// GAVION tasks page: « New task » on /tasks (a company, optionally a contact).
export const tasksEn = {
  new: "New task",
  company: "Company",
  contact_optional: "Contact (optional)",
  assigned_to: "Assigned to",
  reassign: "Reassign",
  reassigned: "Task reassigned to %{name}",
  assigned_current: "current",
  // GAVION task actions: work an open task from /tasks without opening the company
  actions: {
    group: "Actions for task “%{task}”",
    call: "Call",
    email: "Email",
    note: "Note",
    context: "Context",
  },
  note: {
    title: "Note",
    mark_done: "Mark the task done",
    off_crm: "Call made outside the CRM",
  },
  context: {
    title: "Context",
    company: "Company",
    status: "Status",
    phone: "Phone",
    email: "Email",
    rep: "Rep",
    unassigned: "Unassigned",
    deal: "Deal",
    stage: "Stage",
    amount: "Amount",
    history: "Recent history",
    open_company: "Open the record",
  },
};
